import { BLOCK_TYPE, BlockType } from 'models/block';

export const archivedFilterOptions = [
  { label: 'Active', value: false },
  { label: 'Archived', value: true },
];

export const laneLabelByType: Partial<Record<BlockType, string>> = {
  [BLOCK_TYPE.Clinical]: 'Clinical',
  [BLOCK_TYPE.Nutrition]: 'Nutrition',
  [BLOCK_TYPE.MindGut]: 'Mind-Gut',
  [BLOCK_TYPE.BehaviorChange]: 'Behavior Change',
};

// Last engaged within this many days shows as green, otherwise red.
export const RECENTLY_ENGAGED_DAYS = 7;
